export const Facebook = () => (
  <svg
    width="33"
    height="32"
    viewBox="0 0 33 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="facebook (1) 1">
      <path
        id="Vector"
        d="M24.7659 4H7.23407C5.44798 4 4 5.44791 4 7.23405V24.7658C4 26.552 5.44792 27.9999 7.23407 27.9999H15.8807L15.8954 19.4236H13.6673C13.3777 19.4236 13.1427 19.1895 13.1416 18.8999L13.1309 16.1354C13.1298 15.8443 13.3655 15.6077 13.6567 15.6077H15.8807V12.9365C15.8807 9.83661 17.774 8.14869 20.5393 8.14869H22.8085C23.0988 8.14869 23.3342 8.38406 23.3342 8.67444V11.0055C23.3342 11.2957 23.099 11.531 22.8088 11.5312L21.4162 11.5319C19.9123 11.5319 19.6211 12.2465 19.6211 13.2952V15.6078H22.9256C23.2405 15.6078 23.4848 15.8827 23.4477 16.1954L23.12 18.9599C23.0887 19.2244 22.8644 19.4237 22.598 19.4237H19.6359L19.6211 28H24.766C26.5521 28 28 26.5521 28 24.766V7.23405C27.9999 5.44791 26.552 4 24.7659 4Z"
        fill="#80b73f"
      />
    </g>
  </svg>
);
